import { render, staticRenderFns } from "./AppDescriptionMedalleroOlimpico.vue?vue&type=template&id=32ca9c0e&"
import script from "./AppDescriptionMedalleroOlimpico.vue?vue&type=script&lang=js&"
export * from "./AppDescriptionMedalleroOlimpico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports